export default __webpack_public_path__ + "static/media/emoji.db19d6ca.svg";